import * as React from 'react'
import Routes from './router/index'

export const MobileApp = () => <Routes />
